// NATIVE

// INSTALLED

// CUSTOM
import { checkingPreload, unCheckingPreload } from '../loading';
import { setPlansListRedux, setPlanRedux } from './servicesIaPlansSlice';
import { QueryPagination } from '../../commons/interfaces';
import {
  getAllServicesIaPlansService,
  getServicesIaPlanByIdService,
  saveServicesIaPlanService,
  editServicesIaPlanService,
  deleteServicesIaPlanService,
  restoreServicesIaPlanService,
} from '../../services/services-ia-plans.service';

export const getAllServicesIaPlansStore =
  (query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await getAllServicesIaPlansService(query);

      if (response.ok) {
        dispatch(setPlansListRedux(response.data));
      }

      return response;
    } catch (error) {
      console.error(error);

      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const getServicesIaPlanByIdStore = (id: string) => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response = await getServicesIaPlanByIdService(id);

    if (response.ok) {
      dispatch(setPlanRedux(response.data));
    }

    return response;
  } catch (error) {
    console.error(error);

    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const saveServicesIaPlanStore = (data: any) => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response = await saveServicesIaPlanService(data);

    if (response.ok) {
      dispatch(setPlansListRedux(response.data));
    }

    return response;
  } catch (error) {
    console.error(error);

    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const editServicesIaPlanStore = (id: string, data: any) => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response = await editServicesIaPlanService(id, data);

    return response;
  } catch (error) {
    console.error(error);

    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const deleteServicesIaPlanStore =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await deleteServicesIaPlanService(id, query);

      if (response.ok) {
        dispatch(setPlansListRedux(response.data));
      }

      return response;
    } catch (error) {
      console.error(error);

      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const restoreServicesIaPlanStore =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await restoreServicesIaPlanService(id, query);

      if (response.ok) {
        dispatch(setPlansListRedux(response.data));
      }

      return response;
    } catch (error) {
      console.error(error);

      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };
